import classNames from "classnames";
import React, { FunctionComponent } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import NoImage from "src/images/no-image.svg";
import { prefixClassUtil } from "src/utils";
import "./Item.scss";

const PRE_NAME_CLASS = "UpgradesReview-Item";
const prefixClass = prefixClassUtil(PRE_NAME_CLASS);

export interface Props {
    className?: string;
    img?: string | null;
    description?: string;
    price: number;

    onRemove?(): void;
}

const Item: FunctionComponent<Props & WithTranslation> = ({ className, img, description, price, onRemove, t }) => {
    return (
        <div className={classNames(PRE_NAME_CLASS, className)}>
            <div className={prefixClass("main")}>
                <div className={prefixClass("img")}>
                    <img src={img || NoImage} alt="" />
                </div>
                <div className={prefixClass("description")}>{description}</div>
                <div className={prefixClass("third-column")}>
                    <div className={prefixClass("price")}>${price}</div>
                    <div className={prefixClass("action")}>
                        {/* eslint-disable-next-line */}
                        <a onClick={onRemove}>{t("ContinueDeal.UpgradesReview.Item.remove")}</a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default withTranslation()(Item);
